<template>
    <div class="edit-coach-reserve-components">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Board.Personal.title')"
            left>
            <el-form
                ref="form"
                :model="form"
                label-position="right"
                label-width="90px"
                label-suffix=":">
                <el-form-item prop="lessonTime" :label="$t('Lesson.time')">
                    {{ form.lessonTime }}
                </el-form-item>
                <el-form-item prop="followCoachNickname" :label="$t('Common.follow_coach')">
                    {{ form.followCoachNickname }}
                </el-form-item>
                <el-form-item prop="status" :label="$t('Course.appoint_status')">
                    {{ form.status }}
                </el-form-item>
                <el-form-item prop="actualCoachId" :label="$t('Course.coach')">
                    <el-select
                        class="pr-2"
                        v-model="coachId"
                        :placeholder="$t('Common.choose_coach')">
                        <input
                            class="croup-coach"
                            type="text"
                            v-model="searchText" >
                        <el-option
                            v-for="item in filterList"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                            :disabled="item.id == 'no'">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="clientName" :label="$t('Member.name')">
                    {{ form.clientName }}
                </el-form-item>
                <el-form-item prop="clientPhone" :label="$t('Common.phone_number')">
                    {{ form.clientPhone }}
                </el-form-item>
                <el-form-item prop="lessonName" :label="$t('Course.name2')">
                    {{ form.lessonName }}
                </el-form-item>
                <el-form-item prop="lessonCount" :label="$t('Course.class_number')">
                    {{ form.lessonCount }}
                </el-form-item>
                <el-form-item prop="lessonBalance" :label="$t('Course.Coach.remaining_sections')">
                    {{ form.lessonBalance }}
                </el-form-item>
                <el-form-item prop="reservedAt" :label="$t('Reception.Second.appoint_time')">
                    {{ form.reservedAt }}
                </el-form-item>
            </el-form>

            <div class="edit-coach-button">
                <el-button @click="confirm" type="primary">{{ $t('Message.confirm') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Form } from 'element-ui';

export default {
    name: 'editCoachReserve',
    components: {
        ElDialog: Dialog,
        ElForm: Form,
    },
    data() {
        return {
            visible: false,
            form: {},
            coachId: null,
            id: null,
            searchText: null,
            coachs: [],
        };
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.coachs;
            const arr = this.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        open(id) {
            this.id = id;
            this.fetchData();
            this.fetchCoach();
            this.visible = true;
        },
        fetchData() {
            API.get(`lesson/coach/schedule/${this.id}`).then(res => {
                this.form = res;
                this.coachId = res.actualCoachId;
            });
        },
        fetchCoach() {
            API.get(`lesson/coach/schedule/${this.id}/reservable-coach`).then(res => {
                this.coachs = res;
            });
        },
        confirm() {
            API.put(`lesson/coach/schedule/${this.id}`, {
                coachId: this.coachId,
            }).then(() => {
                $ele.$message.success(this.$t('Message.save'));
                this.$emit('fetchData');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.edit-coach-reserve-components {
    .el-dialog {
        width: 500px;
        padding-bottom: 20px;
    }
    .el-dialog__body {
        margin-left: 30px;
    }
    .edit-coach-button {
        display: inline-block;
        position: relative;
        left: 50%;
        transform: translateX(calc(-50% - 15px));
    }
}
</style>
